import { FC, useState } from 'react';
import { CreditProvider } from '../../../types/wallet';
import { Icon } from '../../basics';
import useEndPoints from '../../../states/hooks/useEndpoints/useEndpoints';
import axios from 'axios';
import useAuth from '../../../states/hooks/useAuth/useAuth';

type Props = {
    provider: CreditProvider;
    onCreated?: () => void;
    onError?: () => void;
};

const CreateWalletCard: FC<Props> = ({ provider, onCreated, onError }) => {
    const { user, refreshUser } = useAuth();
    const [ isCreating, setIsCreating ] = useState(false);
    const endpoints = useEndPoints();
    
    const addWalletToUser = async () => {
        try {
            setIsCreating(true);
            await axios(endpoints.user.addWallet, { 
                method: 'POST',
                data: {
                    provider: provider.id
                },
                headers: {
                    'Authorization': 'Bearer ' + user?.token
                }
            });
            if (!!onCreated) { 
                onCreated()
                setIsCreating(false);
                refreshUser();
            }
        } catch {
            if (!!onError) {
                onError()
                setIsCreating(false);
            } 
        }  
    }
    
    return (
        <div 
            onClick={ addWalletToUser }
            className="bg-stone-50 dark:bg-stone-800 border border--themed border-dashed p-5 rounded-xl select-none"
        >
            <div>
                { provider.label ? <h3 className="text-xl text--main">{ provider.label }</h3> : <h3 className="text-xl text--secondary">Geen naam</h3> }
            </div>
            <div className="label text-stone-500 flex items-center mt-1">
                <span>{ isCreating ? 'Wallet aanmaken ...' : 'Deelnemen aan wallet' }</span>
                { !isCreating && <Icon name="add" size="1rem" className="ml-1" />}
            </div>
        </div>
    )
}

export default CreateWalletCard;